import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { forgotPassword } from '../../lib/auth-api'
import Link from '@material-ui/core/Link'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
}))

const formSchema = yup.object().shape({
  username: yup.string().required('This field is required'),
})

const PasswordResetForm = ({ onSuccess }) => {
  const classes = useStyles()
  const [submissionError, setSubmissionError] = useState(null)
  const { register, handleSubmit, errors, formState } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(formSchema),
  })
  const { isSubmitting } = formState

  const confirmAccountErrorLink = (username, submissionError) => {
    return (
      <>
        <FormHelperText error={true}>{submissionError}</FormHelperText>
        <Link style={{ textAlign: 'center' }} component={RouterLink} to={`/confirm-account?username=${encodeURIComponent(username)}`}>
          Click here to confirm the account.
        </Link>
      </>
    )
  }

  const onFormSubmit = async (formValues) => {
    setSubmissionError(null)
    const resp = await forgotPassword(formValues.username)
    if (resp.success) {
      onSuccess && onSuccess({ username: formValues.username, message: resp.message })
    } else {
      if (resp.message === 'Please confirm your account before issuing a password reset') {
        setSubmissionError(confirmAccountErrorLink(formValues.username, resp.message))
      } else {
        setSubmissionError(<FormHelperText error={true}>{resp.message}</FormHelperText>)
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <TextField
        className={classes.formField}
        name="username"
        label="Email"
        inputRef={register}
        error={!!errors.username}
        helperText={errors.username && errors.username.message}
      />
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        type="submit"
        disabled={isSubmitting}
      >
        Reset My Password
      </Button>
      {submissionError}
    </form>
  )
}

export default PasswordResetForm
